// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pc-page {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.pc-section .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.pc-status-grid,
.pc-form-grid,
.pc-two-column {
    display: grid;
    gap: 1rem;
}

.pc-status-grid {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.pc-status-grid > div {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    padding: 0.8rem;
}

.pc-status-grid strong,
.pc-status-grid span {
    display: block;
}

.pc-status-grid strong {
    margin-bottom: 0.25rem;
}

.pc-form-grid,
.pc-two-column {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

.pc-warning-list,
.pc-doc-summary {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.pc-warning-row,
.pc-doc-summary-row {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    padding: 0.9rem;
}

.pc-warning-row.is-selected {
    border-color: var(--accent-color, #b22);
}

.pc-warning-row p {
    margin: 0.35rem 0 0.65rem;
}

.pc-warning-actions,
.pc-action-row {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.pc-warning-actions {
    justify-content: flex-end;
}

.pc-req-btn {
    font-size: 0.8rem;
    padding: 0.2rem 0.55rem;
}

@media (max-width: 720px) {
    .pc-warning-actions {
        justify-content: flex-start;
    }
}

.pc-pill {
    border-radius: 999px;
    display: inline-flex;
    font-size: 0.85rem;
    line-height: 1;
    padding: 0.35rem 0.55rem;
}

.pc-pill.success {
    background: #e8f5ee;
    color: #126534;
}

.pc-pill.warning {
    background: #fff4d8;
    color: #7a5200;
}
[data-theme="dark"] .pc-status-grid > div,
[data-theme="dark"] .pc-warning-row,
[data-theme="dark"] .pc-doc-summary-row,
[data-theme="dark"] .pc-upload-form,
[data-theme="dark"] .pc-two-column form { border-color: rgba(255, 255, 255, 0.15); }
[data-theme="dark"] .pc-pill.success { background: #16301f; color: #8fd6a0; }
[data-theme="dark"] .pc-pill.warning { background: #3a2c10; color: #e0b360; }

.pc-page .button.danger {
    background: #8f1d1d;
    color: #fff;
}

.pc-doc-summary-row {
    align-items: flex-start;
    display: flex;
    gap: 1rem;
    justify-content: space-between;
}

.pc-doc-summary-row ul {
    margin-bottom: 0;
}

.pc-checkbox-grid {
    display: grid;
    gap: 0.35rem 1rem;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
}

.pc-table {
    width: 100%;
}

.pc-table td,
.pc-table th {
    vertical-align: top;
}

.pc-upload-form {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-bottom: 1rem;
}

.pc-two-column form {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    padding: 1rem;
}

.pc-two-column h3,
.pc-policy-modal h3 {
    font-size: 1.05rem;
    margin-top: 0;
}

@media (max-width: 720px) {
    .pc-doc-summary-row {
        display: block;
    }

    .pc-action-row .button {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Product/ProductCompliancePage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;;IAGI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;IAEI,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;;;;0CAI0C,uCAAuC,EAAE;AACnF,uCAAuC,mBAAmB,EAAE,cAAc,EAAE;AAC5E,uCAAuC,mBAAmB,EAAE,cAAc,EAAE;;AAE5E;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,2DAA2D;AAC/D;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;IAC5C,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".pc-page {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.pc-section .content {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.pc-status-grid,\n.pc-form-grid,\n.pc-two-column {\n    display: grid;\n    gap: 1rem;\n}\n\n.pc-status-grid {\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n}\n\n.pc-status-grid > div {\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    border-radius: 6px;\n    padding: 0.8rem;\n}\n\n.pc-status-grid strong,\n.pc-status-grid span {\n    display: block;\n}\n\n.pc-status-grid strong {\n    margin-bottom: 0.25rem;\n}\n\n.pc-form-grid,\n.pc-two-column {\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n}\n\n.pc-warning-list,\n.pc-doc-summary {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.pc-warning-row,\n.pc-doc-summary-row {\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    border-radius: 6px;\n    padding: 0.9rem;\n}\n\n.pc-warning-row.is-selected {\n    border-color: var(--accent-color, #b22);\n}\n\n.pc-warning-row p {\n    margin: 0.35rem 0 0.65rem;\n}\n\n.pc-warning-actions,\n.pc-action-row {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.pc-warning-actions {\n    justify-content: flex-end;\n}\n\n.pc-req-btn {\n    font-size: 0.8rem;\n    padding: 0.2rem 0.55rem;\n}\n\n@media (max-width: 720px) {\n    .pc-warning-actions {\n        justify-content: flex-start;\n    }\n}\n\n.pc-pill {\n    border-radius: 999px;\n    display: inline-flex;\n    font-size: 0.85rem;\n    line-height: 1;\n    padding: 0.35rem 0.55rem;\n}\n\n.pc-pill.success {\n    background: #e8f5ee;\n    color: #126534;\n}\n\n.pc-pill.warning {\n    background: #fff4d8;\n    color: #7a5200;\n}\n[data-theme=\"dark\"] .pc-status-grid > div,\n[data-theme=\"dark\"] .pc-warning-row,\n[data-theme=\"dark\"] .pc-doc-summary-row,\n[data-theme=\"dark\"] .pc-upload-form,\n[data-theme=\"dark\"] .pc-two-column form { border-color: rgba(255, 255, 255, 0.15); }\n[data-theme=\"dark\"] .pc-pill.success { background: #16301f; color: #8fd6a0; }\n[data-theme=\"dark\"] .pc-pill.warning { background: #3a2c10; color: #e0b360; }\n\n.pc-page .button.danger {\n    background: #8f1d1d;\n    color: #fff;\n}\n\n.pc-doc-summary-row {\n    align-items: flex-start;\n    display: flex;\n    gap: 1rem;\n    justify-content: space-between;\n}\n\n.pc-doc-summary-row ul {\n    margin-bottom: 0;\n}\n\n.pc-checkbox-grid {\n    display: grid;\n    gap: 0.35rem 1rem;\n    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n}\n\n.pc-table {\n    width: 100%;\n}\n\n.pc-table td,\n.pc-table th {\n    vertical-align: top;\n}\n\n.pc-upload-form {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    padding-bottom: 1rem;\n}\n\n.pc-two-column form {\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    border-radius: 6px;\n    padding: 1rem;\n}\n\n.pc-two-column h3,\n.pc-policy-modal h3 {\n    font-size: 1.05rem;\n    margin-top: 0;\n}\n\n@media (max-width: 720px) {\n    .pc-doc-summary-row {\n        display: block;\n    }\n\n    .pc-action-row .button {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
